module.exports = __webpack_public_path__ + "static/media/check-blue.cb2aeb95.svg";